import useScrolledOut from '@anm/hooks/useScrolledOut';
import { useScrollDirection } from '@anm/hooks/useScrollingUp';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { projectSelectors } from '../../../store/modules/project';

import Buttons from './Buttons';
import {
  ContentWrapper,
  DashboardTitleBlock,
  HeaderButtonsWrapper,
  HeaderWrapper,
  LayoutButtonsWrapper,
  LeftBarContent,
  Navbar,
  NavButton,
  StickyWrapper
} from './Wrapper';
import { LeftBarLayoutProps, ListElement } from './types';

export { HeaderButtonsWrapper, DashboardTitleBlock, HeaderWrapper, ContentWrapper, NavButton, Navbar };

export * from './types';

const LeftBarLayout: FC<LeftBarLayoutProps> = ({
  list,
  variant = 'full-size',
  showNavigationDropdownBreakpoint,
  activeButton,
  navButtonVariant,
  onActionSheetOpen,
  renderInnerContent,
  renderNavTopContent,
  onActiveButtonChange,
  renderNavRightContent,
  renderNavBottomContent
}) => {
  const isSearchOpen = useSelector(projectSelectors.selectSearchOpenStatus);

  const showNavBottomContent = activeButton === 0;
  const isDomainsTab = activeButton === 8;
  const listWithButton = list.filter(({ button }) => !!button) as ListElement[];
  const isScrolled = useScrolledOut(30);
  const scrollDirection = useScrollDirection();
  const canRenderTitle = list[activeButton]?.title;
  const button = list.find(item => item.button?.index === activeButton) || list[activeButton];

  return (
    <>
      <Navbar id="left-navbar">
        <StickyWrapper>
          {renderNavTopContent?.()}
          <LayoutButtonsWrapper hasRightContent={!!renderNavRightContent}>
            <Buttons
              {...{
                activeButton,
                onActiveButtonChange,
                onActionSheetOpen,
                navButtonVariant,
                showNavigationDropdownBreakpoint
              }}
              list={listWithButton}
            />
            {renderNavRightContent?.()}
          </LayoutButtonsWrapper>
          {renderNavBottomContent && renderNavBottomContent(showNavBottomContent)}
        </StickyWrapper>
      </Navbar>
      <ContentWrapper
        {...{ variant }}
        id="left-bar-content"
        isPadding={!isDomainsTab}
        isScrolled={!isSearchOpen && isScrolled}
        scrollDirection={!isSearchOpen && scrollDirection}
      >
        {renderInnerContent?.() || (
          <>
            {canRenderTitle && (
              <HeaderWrapper>
                <DashboardTitleBlock size="medium" title={button.title} />
                {button.renderRightButtons && (
                  <HeaderButtonsWrapper>{button?.renderRightButtons?.()}</HeaderButtonsWrapper>
                )}
              </HeaderWrapper>
            )}

            <LeftBarContent>{button?.renderContent?.()}</LeftBarContent>
          </>
        )}
      </ContentWrapper>
    </>
  );
};

export default LeftBarLayout;
